"use strict";

var _Object$defineProperty = require("@babel/runtime-corejs3/core-js-stable/object/define-property");
var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");
_Object$defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _set = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/set"));
var _isArray = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/array/is-array"));
var _trim = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/trim"));
// NOTE: this is not intented to be instantiated, only inherited
class BaseClient {
  constructor(config) {
    this._initialized = false;
    this._loggedIn = false;
    this._userInfo = {};
    this._authRefreshRegister = new _set.default();
    if (config) {
      this.init(config);
    }
  }
  registerAuthRefresh(fn) {
    this._authRefreshRegister.add(fn);
  }
  unregisterAuthRefresh(fn) {
    this._authRefreshRegister.delete(fn);
  }
  init(config) {
    this._clientId = config.clientId;

    // NOTE: inheriting class should set this._initialized = true on success
  }

  logIn() {
    if (this.loggedIn) {
      throw 'auth client is already logged in';
    }
    if (!this.initialized) {
      throw 'auth client is not initialized';
    }

    // NOTE: inheriting class should set this._loggedIn = true on success
  }

  logOut() {
    throw 'logOut() is not implemented in base client';
    // NOTE: inheriting class should set this._loggedIn = false on success
  }

  get initialized() {
    return this._initialized;
  }
  get loggedIn() {
    return this._loggedIn;
  }
  get clientId() {
    return this._clientId;
  }
  get accessToken() {
    if (this._loggedIn) {
      return this._accessToken;
    }
  }
  get accessTokenPayload() {
    if (this._loggedIn) {
      return this._accessTokenPayload;
    }
  }
  get accessTokenExp() {
    if (this._loggedIn) {
      return this._accessTokenPayload.exp * 1000; // to milliseconds
    }
  }

  get refreshToken() {
    if (this._loggedIn) {
      return this._refreshToken;
    }
  }
  get refreshTokenPayload() {
    if (this._loggedIn) {
      return this._refreshTokenPayload;
    }
  }
  get refreshTokenExp() {
    if (this._loggedIn && this._refreshTokenPayload) {
      return this._refreshTokenPayload.exp * 1000; // to milliseconds
    }
  }

  _getUserInfo(key) {
    // no guarantee that userInfo will have any field that is not required by
    // the OIDC spec
    if (key in this._userInfo) {
      var _context2;
      /*
        The way UserManager handles Unicode entries - it replaces the (string) entry with an array, containing multiple entries.
        Example: ['LÃ¯an', 'Lïan']
        As such, we're picking second entry from that array to display.
      */
      if ((0, _isArray.default)(this._userInfo[key])) {
        var _context;
        return (0, _trim.default)(_context = this._userInfo[key][1]).call(_context);
      }
      // trim userInfo fields: https://www.pivotaltracker.com/story/show/176180296
      return (0, _trim.default)(_context2 = this._userInfo[key]).call(_context2);
    }
  }
  get userName() {
    return this._getUserInfo('preferred_username');
  }
  get name() {
    return this._getUserInfo('name');
  }
  get givenName() {
    return this._getUserInfo('given_name');
  }
  get fullName() {
    return this.name;
  }
  get familyName() {
    return this._getUserInfo('family_name');
  }
  get email() {
    return this._getUserInfo('email');
  }
  get accountId() {
    if (this._loggedIn) {
      // `accountId` is listed as "always present":
      //  https://autonomic-ai.atlassian.net/wiki/spaces/DA/pages/1099890871/JWTs
      return this._accessTokenPayload.accountId;
    }
  }
  get docAccess() {
    if (this._loggedIn) {
      var _context3;
      return (0, _trim.default)(_context3 = this._accessTokenPayload.doc_access || '').call(_context3);
    }
  }
  _onAuthRefreshSuccess() {
    for (let fn of this._authRefreshRegister) {
      try {
        fn(this);
      } catch (e) {
        console.error('failed auth refresh callback', e); // eslint-disable-line no-console
      }
    }
  }
}
exports.default = BaseClient;